import React from "react";
import {downLoadFile} from "../../helpers/functions";

const AttachmentsList = (props) => {
    const {attachments, onAttachmentRemove, onAttachmentRequest} = props;

    return (
        <ul className="newApplication-attachment-list">
            {
                attachments.map((attachment, index) => {
                    return <li key={index}>
                        <div className="row">
                            <div className="col-sm-12 attachment-remove__wrapper">
                                {onAttachmentRemove && [
                                    <div
                                        key={1}
                                        className="attachment-remove"
                                        onClick={() => onAttachmentRemove(attachment, index)}>
                                        X
                                    </div>,
                                    ' '
                                ]}
                                {
                                    (attachment.encodedFile || onAttachmentRequest) ?
                                        <span
                                            className={attachment.encodedFile || onAttachmentRequest? "downloadable" : ""}
                                            onClick={
                                                onAttachmentRequest ?
                                                    () => onAttachmentRequest(attachment)
                                                    :
                                                    () => downLoadFile(attachment.name, attachment.encodedFile)
                                            }
                                        >
                                            {attachment.name}
                                        </span>
                                        :
                                        <span>{attachment.name}</span>
                                }
                            </div>
                        </div>
                    </li>
                })
            }
        </ul>
    )
};

export default AttachmentsList;